// extracted by mini-css-extract-plugin
export default {"multiInputLabel":"MultipleInput_multiInputLabel__Gz6Ce","textArea":"MultipleInput_textArea__kRaGU","questionRow":"MultipleInput_questionRow__i+5FR"};